<template>
  <section>
    <div class="mt-5 mb-3 ml-0 mr-0 text-left">
      <b-card>
        <b-card-text>
          <h3>
            <font-awesome-icon icon="folder-open"></font-awesome-icon>
            {{ showTitle }}
            <span class="float-right" v-if="showCreateBtn">
<!--              <router-link class="btn btn-md bg-orange" :to="{name: 'resourceAdd'}">Add a new resource</router-link>-->
              <router-link class="btn btn-md bg-orange" :to="{name: 'resourceAdd'}">Add a new ingredient</router-link>
            </span>
          </h3>
        </b-card-text>
        <hr>
        <b-card-text>
          <div class="mb-3">
            <ResourcesList v-bind:resources="resources" ></ResourcesList>
          </div>
          <div class="overflow-auto" v-if="showPagination">
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.totalCount"
              :per-page="pagination.pageSize"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              align="center"
              @input="getResources">
            </b-pagination>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </section>
</template>

<script>
import ResourcesList from './ResourcesList'
export default {
  name: 'ResourcesSection',
  data () {
    return {
      resources: [],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 8
      }
    }
  },
  props: {
    'type': String
  },
  components: {
    ResourcesList
  },
  created () {
    this.getResources()
  },
  computed: {
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize
    },
    showCreateBtn: function () {
      // display or not the creation btn
      return this.type === 'OWN'
    },
    showTitle: function () {
      // get the type of displayed ingredients
      if (this.type === 'OWN') {
        return 'My Ingredients'
      } else if (this.type === 'SHARE') {
        return 'Shared Ingredients'
      } else if (this.type === 'BOOKMARKED') {
        return 'Bookmarked Ingredients'
      }
    }
  },
  methods: {
    initResources: function () {
      this.resources = []
    },
    getResources: function () {
      // Fetch a list of my resources
      let params = {
        status: this.type,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize
      }
      // get data
      let tempResources = []
      this.$store.dispatch('getResourcesList', params).then(
        data => {
          tempResources = data.results
          this.pagination.totalCount = data.totalCount
          this.initResources()

          // adjust resource entities
          tempResources.forEach(
            resource => {
              let temp = resource
              temp.isShared = false
              this.resources.push(temp)
            }
          )
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcesSection.vue